<template>
    <div class="text-center h70 pt100">
        <h1>404</h1>
        <p>{{ $t("button.404") }}</p>
    </div>
</template>

<script>
export default {
    name: "404"
};
</script>

<style lang="less">
</style>